import { labelTipoCliente } from '../config/tipoClienteOptions';

export const TIPO_CLIENTE_SUSPENDIDO = 'S';

export type BloqueoClienteSuspendidoModo = 'soft' | 'hard' | 'alert';

export const BLOQUEO_CLIENTE_SUSPENDIDO_OPCIONES: {
  value: BloqueoClienteSuspendidoModo;
  label: string;
}[] = [
  { value: 'alert', label: 'ALERT — Solo alerta visual (default)' },
  { value: 'soft', label: 'SOFT — Alerta + confirmación al guardar/emitir' },
  { value: 'hard', label: 'HARD — Bloqueo (no permite guardar ni emitir)' },
];

export const CONFIG_SECCION_VENTAS = 'VENTAS';
export const CONFIG_CAMPO_CLIENTE_SUSPENDIDO_BLOQUEO = 'CLIENTE:SUSPENDIDO:BLOQUEO';

export const esClienteSuspendido = (tipoCliente?: string | null): boolean =>
  String(tipoCliente ?? '').trim().toUpperCase() === TIPO_CLIENTE_SUSPENDIDO;

export const normalizarNotasCliente = (notas?: string | null): string =>
  String(notas ?? '').replace(/\s+/g, ' ').trim();

export const parseBloqueoClienteSuspendidoFactura = (
  valor?: string | null,
): BloqueoClienteSuspendidoModo => {
  const v = String(valor ?? '').trim().toUpperCase();
  if (v === 'HARD' || v === '2') return 'hard';
  if (v === 'SOFT' || v === '1') return 'soft';
  if (v === 'ALERT' || v === '0' || v === 'NONE' || v === 'SOLO') return 'alert';
  return 'alert';
};

export const valorConfigBloqueoClienteSuspendido = (
  modo: BloqueoClienteSuspendidoModo,
): string => modo.toUpperCase();

export const mensajeConfirmacionClienteSuspendido = (
  nroCliente?: number,
  nombre?: string | null,
): string => {
  const detalleNombre = String(nombre ?? '').trim();
  const identificacion = nroCliente && nroCliente > 0
    ? `#${nroCliente}${detalleNombre ? ` (${detalleNombre})` : ''}`
    : detalleNombre || 'seleccionado';
  return `El cliente ${identificacion} está ${labelTipoCliente(TIPO_CLIENTE_SUSPENDIDO).toLowerCase()}. ¿Desea continuar con la facturación de todos modos?`;
};

export const mensajeHardBlockClienteSuspendido = (
  nroCliente?: number,
  nombre?: string | null,
): string => {
  const detalleNombre = String(nombre ?? '').trim();
  const identificacion = nroCliente && nroCliente > 0
    ? `#${nroCliente}${detalleNombre ? ` (${detalleNombre})` : ''}`
    : detalleNombre || 'seleccionado';
  return `El cliente ${identificacion} está ${labelTipoCliente(TIPO_CLIENTE_SUSPENDIDO).toLowerCase()}. La configuración del sistema no permite facturar clientes suspendidos.`;
};

export const textoAlertaClienteSuspendido = (
  modo: BloqueoClienteSuspendidoModo,
): string => {
  switch (modo) {
    case 'hard':
      return 'No podés guardar ni emitir mientras el cliente esté suspendido.';
    case 'alert':
      return 'Podés continuar con la facturación; esta es solo una alerta informativa.';
    default:
      return 'Podés continuar, pero se solicitará confirmación al guardar o emitir.';
  }
};

export const severidadAlertaClienteSuspendido = (
  modo: BloqueoClienteSuspendidoModo,
): 'error' | 'warning' | 'info' => {
  if (modo === 'hard') return 'error';
  if (modo === 'soft') return 'warning';
  return 'info';
};
